import { useTranslation } from 'react-i18next';

import { LoadingAnimation } from 'shared/components';

export const Authenticating = () => {
    const { t } = useTranslation();
    return <LoadingAnimation text={t('authenticating')} />;
};
